import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskLiveChatMyChatsRoute: InvariantJiraRoute = {
	name: 'servicedesk-live-chat-my-chats',
	path: '/jira/servicedesk/projects/:projectKey/live-chat',
	exact: true,
};
